module.exports = __webpack_public_path__ + "static/media/PoKoRoIcon.78919e33.svg";